import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var __jsx = React.createElement;
import React from 'react';
import styled from 'styled-components';
import ReactPaginate from 'react-paginate';
import Spinner from './shared/ui/Spinner';
import Caret from './shared/icons/Caret';
import { colorPalette, textStyles } from '../styles/styleGuide';
var Pagination = function Pagination(_ref) {
  var isLoading = _ref.isLoading,
    totalPages = _ref.totalPages,
    currentPage = _ref.currentPage,
    visiblePages = _ref.visiblePages,
    goToPageValue = _ref.goToPageValue;
  return __jsx(PaginationBlock, {
    "data-id": "components_Pagination_PaginationBlock"
  }, __jsx(SpinnerContainer, {
    isLoading: isLoading,
    "data-id": "components_Pagination_SpinnerContainer"
  }, __jsx(Spinner, {
    monochrome: true,
    color: colorPalette.lightBlue,
    size: "small",
    "data-id": "components_Pagination_Spinner"
  })), __jsx(PaginationContainer, {
    "data-id": "components_Pagination_PaginationContainer"
  }, __jsx(PrevCaret, {
    "data-id": "components_Pagination_PrevCaret"
  }, __jsx(Caret, {
    direction: "left",
    color: colorPalette.white,
    scale: 0.9,
    "data-id": "components_Pagination_Caret"
  })), __jsx(NextCaret, {
    "data-id": "components_Pagination_NextCaret"
  }, __jsx(Caret, {
    direction: "right",
    color: colorPalette.white,
    scale: 0.9,
    "data-id": "components_Pagination_Caret"
  })), __jsx(ReactPaginate, {
    pageCount: totalPages,
    pageRangeDisplayed: visiblePages,
    disableInitialCallback: true,
    marginPagesDisplayed: 1,
    forcePage: currentPage,
    initialPage: currentPage,
    previousLabel: "<",
    nextLabel: ">",
    onPageChange: function onPageChange(goToPageNumber) {
      return goToPageValue(goToPageNumber.selected + 1);
    },
    "data-id": "components_Pagination_ReactPaginate"
  })));
};
export default Pagination;
var PaginationContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n"])));
var SpinnerContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  opacity: ", ";\n  position: absolute;\n  left: -60rem;\n  box-sizing: border-box;\n  padding: 5rem;\n  width: 35rem;\n  height: 35rem;\n\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    top: -60rem;\n  }\n"])), function (props) {
  return props.isLoading ? '1' : '0';
});
var PaginationBlock = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n\n  ul {\n    display: inline-block;\n    overflow: hidden;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    float: left;\n\n    li {\n      display: inline-block;\n      color: ", ";\n\n      &.selected {\n        a {\n          color: #ffffff;\n          pointer-events: none;\n          background-color: ", ";\n        }\n      }\n\n      &.break {\n        margin-left: 10rem;\n        margin-right: 10rem;\n      }\n\n      &.previous,\n      &.next {\n        a {\n          cursor: pointer;\n          text-indent: -1000rem;\n          z-index: 1;\n          opacity: 0.85;\n          background-color: ", ";\n          width: 32rem;\n          min-width: none;\n          margin: 0;\n          height: 32rem;\n          border-radius: 50%;\n          transition: opacity 0.2s ease-in-out;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          -webkit-tap-highlight-color: transparent;\n\n          &:hover {\n            opacity: 1;\n            background-color: ", ";\n          }\n        }\n\n        &.disabled {\n          opacity: 0.3;\n          pointer-events: none;\n        }\n      }\n\n      &.previous {\n        margin-right: 10rem;\n      }\n\n      &.next {\n        margin-left: 10rem;\n      }\n\n      > a {\n        outline: none;\n        ", ";\n        font-weight: bold;\n        text-decoration: none;\n        color: ", ";\n        cursor: pointer;\n        background-color: transparent;\n        padding: 4rem 8rem;\n        margin: 0 2rem;\n        display: inline-block;\n        box-sizing: border-box;\n        text-align: center;\n        min-width: 34rem;\n        border-radius: 4rem 0;\n        transition: 0.3s ease-in-out;\n\n        &:hover {\n          color: #ffffff;\n          background-color: ", ";\n        }\n      }\n    }\n  }\n"])), colorPalette.textGrey, colorPalette.lightBlue, colorPalette.lightBeige, colorPalette.lightBeige, textStyles.bodyText, colorPalette.beige, colorPalette.lightBlue);
var PrevCaret = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 6rem;\n  left: 8rem;\n  z-index: 1;\n  pointer-events: none;\n"])));
var NextCaret = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 6rem;\n  right: 8rem;\n  z-index: 1;\n  pointer-events: none;\n"])));